import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Clears every in-memory selection when a reset is requested. */
export const resetSelections = store.effects.create(
  (feature: Plugin['feature'], selectionStorage: Plugin['selectionStorage']) =>
    feature.actions.resetSelections.relay(forwardTo =>
      rxjs.of(
        forwardTo(selectionStorage.actions.setLookup, {
          input: {},
        }),
      ),
    ).asObservable,
)
